// Keyboard shortcuts (single keys; ignored while typing in a field).

export const SHORTCUTS = {
  /** laptop shell: pin the navigation rail open / collapse it */
  toggleRail: '[',
  /** overview: monitor (kiosk) mode on / off; Escape also leaves it */
  monitor: 'm',
} as const;
